import React, { useMemo } from 'react';

const AdminDashboardStatCard = ({ title, value, icon, color, description, testId }) => (
  <div className={`bg-white rounded-xl shadow-sm p-6 border-l-4 ${color}`} data-testid={testId}>
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-600 text-sm">{title}</p>
        <p className="text-3xl font-bold text-gray-900 mt-1" data-testid={`${testId}-value`}>{value}</p>
        {description && <p className="text-gray-500 text-sm mt-1">{description}</p>}
      </div>
      <div className="text-4xl">{icon}</div>
    </div>
  </div>
);

export const AdminDashboardOverviewTab = ({ metrics, allProjects, onOpen3DProject }) => {
  const projectsToday = useMemo(() => {
    const today = new Date().toDateString();
    return allProjects.filter((project) => new Date(project.created_at).toDateString() === today).length;
  }, [allProjects]);

  const uniqueUsers = useMemo(() => new Set(allProjects.map((project) => project.user_email)).size, [allProjects]);

  return (
    <div className="space-y-6" data-testid="admin-dashboard-overview-tab">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="admin-dashboard-stats-grid">
        <AdminDashboardStatCard title="Total de Projetos" value={metrics?.total_projects || 0} icon="📁" color="border-blue-500" testId="admin-dashboard-stat-total-projects" />
        <AdminDashboardStatCard title="Visualizações 3D" value={metrics?.total_3d_views || 0} icon="👁️" color="border-purple-500" testId="admin-dashboard-stat-total-3d-views" />
        <AdminDashboardStatCard title="Projetos Hoje" value={projectsToday} icon="📅" color="border-green-500" testId="admin-dashboard-stat-projects-today" />
        <AdminDashboardStatCard title="Usuários Únicos" value={uniqueUsers} icon="👥" color="border-orange-500" testId="admin-dashboard-stat-unique-users" />
      </div>

      <div className="bg-white rounded-xl shadow-sm" data-testid="admin-dashboard-most-viewed-card">
        <div className="p-6 border-b">
          <h2 className="text-lg font-semibold text-gray-900" data-testid="admin-dashboard-most-viewed-title">🏆 Projetos Mais Visualizados em 3D</h2>
        </div>

        <div className="divide-y">
          {metrics?.most_viewed_projects?.length > 0 ? (
            metrics.most_viewed_projects.map((project, index) => (
              <div key={project.id} className="p-4 flex items-center justify-between hover:bg-gray-50" data-testid={`admin-dashboard-most-viewed-row-${project.id}`}>
                <div className="flex items-center gap-4">
                  <span
                    className={`w-8 h-8 rounded-full flex items-center justify-center text-white font-bold ${
                      index === 0 ? 'bg-yellow-500' : index === 1 ? 'bg-gray-400' : index === 2 ? 'bg-orange-400' : 'bg-gray-300'
                    }`}
                    data-testid={`admin-dashboard-most-viewed-rank-${project.id}`}
                  >
                    {index + 1}
                  </span>
                  <div>
                    <p className="font-medium text-gray-900" data-testid={`admin-dashboard-most-viewed-name-${project.id}`}>{project.name}</p>
                    <p className="text-sm text-gray-500" data-testid={`admin-dashboard-most-viewed-owner-${project.id}`}>{project.user_name || 'Anônimo'}</p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <span className="text-purple-600 font-semibold" data-testid={`admin-dashboard-most-viewed-count-${project.id}`}>{project.view_count_3d} views</span>
                  <button
                    onClick={() => onOpen3DProject(project.id)}
                    className="px-3 py-1 bg-purple-100 text-purple-700 rounded-lg text-sm hover:bg-purple-200"
                    data-testid={`admin-dashboard-most-viewed-open-3d-${project.id}`}
                  >
                    Ver 3D
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="p-8 text-center text-gray-500" data-testid="admin-dashboard-most-viewed-empty">
              Nenhum projeto visualizado em 3D ainda
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
